import { render, staticRenderFns } from "./SelectImage.vue?vue&type=template&id=2473b8ea&scoped=true"
import script from "./SelectImage.vue?vue&type=script&lang=js"
export * from "./SelectImage.vue?vue&type=script&lang=js"
import style0 from "./SelectImage.vue?vue&type=style&index=0&id=2473b8ea&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473b8ea",
  null
  
)

export default component.exports